export default __webpack_public_path__ + "static/media/v.392e2094.svg";